import { configureStore } from "@reduxjs/toolkit";
import codeOverviewReducer from "./reducers/codeOverview";
import commonReducer from "./reducers/common";
import codeConversionReducer from "./reducers/codeConversion";
import databaseConversionReducer from "./reducers/databaseConversion";
import codeSpecificationReducer from "./reducers/CodeSpecification";
import CodeDocumentationReducer from "./reducers/CodeDocumentation";
import unitTestReducer from "./reducers/unitTest";
import codeAuditReducer from "./reducers/codeAudit";
import authReducer from "./reducers/authReducer";
import architectureConversionReducer from "./reducers/architectureConversion";
import caseScenariosReducer from "./reducers/caseScenarios";
import registrationReducer from "./reducers/registration";
import securityValidatorReducer from "./reducers/securityValidator";
import forgotPasswordReducer from "./reducers/forgotPassword";
import changePasswordReducer from "./reducers/changePassword";
import userListReducer from "./reducers/userList";
import profileReducer from "./reducers/profile";
import conversionHistoryReducer from "./reducers/conversionHistory";
import versionUpgradeReducer from "./reducers/versionUpgrade";
// import { saveStateToLocalStorage, loadStateFromLocalStorage } from "./localStorage.js";
// import { saveStateToLocalStorage, loadStateFromLocalStorage } from "./localStorage.js";

// Load state from localStorage if available
// const preloadedState = loadStateFromLocalStorage();

export const store = configureStore({
  reducer: {
    common: commonReducer,
    codeOverview: codeOverviewReducer,
    codeConversion: codeConversionReducer,
    databaseConversion: databaseConversionReducer,
    CodeSpecification: codeSpecificationReducer,
    CodeDocumentation: CodeDocumentationReducer,
    unitTest: unitTestReducer,
    codeAudit: codeAuditReducer,
    auth: authReducer,
    architectureConversion: architectureConversionReducer,
    caseScenarios: caseScenariosReducer,
    registration: registrationReducer,
    securityValidator: securityValidatorReducer,
    forgotPassword: forgotPasswordReducer,
    changePassword: changePasswordReducer,
    userList: userListReducer,
    profile: profileReducer,
    conversionHistory: conversionHistoryReducer,
    versionUpgrade: versionUpgradeReducer
  },
  devTools: process.env.NODE_ENV !== "production",
  // preloadedState
})

// Subscribe to store changes and persist them
// store.subscribe(() => {
//   saveStateToLocalStorage(store.getState()); // Save the whole state or a part of it
// });

export default store;
